import ManageChatReportPage from './ManageChatReportPage';

export default ManageChatReportPage;
export { default as reducer } from './chatReport.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageChatReportPage/index.tsx